import { DriveTypeEnum, EngineTypeList, } from '@zurich/api/contract';
import { createArrayUtils, createStringEnumUtils, UnknownType, } from '@zurich/common/utils';
export const engineTypeUtils = createArrayUtils(EngineTypeList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:engineType',
});
export const driveTypeUtils = createStringEnumUtils(DriveTypeEnum, {
    translationPrefix: 'contract:engineType',
    unknownType: UnknownType.STRING,
});
export const getEngineTypeEnum = (values) => {
    const { engineType, fuelType1, fuelType2 } = values;
    if (engineType === 'petrol' ||
        (engineType === 'ice' && fuelType1 === 'petrol')) {
        return DriveTypeEnum.BENZIN;
    }
    if (engineType === 'diesel' ||
        (engineType === 'ice' && fuelType1 === 'diesel')) {
        return DriveTypeEnum.DIESEL;
    }
    if (engineType === 'electro') {
        return DriveTypeEnum.ELEKTRO;
    }
    if (engineType === 'hybrid' &&
        fuelType1 === 'hydrogen' &&
        fuelType2 === 'electric') {
        return DriveTypeEnum.HYBRID_WASSERSTOFF_ELEKTRO;
    }
    if (engineType === 'hybrid') {
        return DriveTypeEnum.HYBRID_ELEKTRO;
    }
    if (engineType === 'ice' &&
        fuelType1 === undefined &&
        fuelType2 === undefined) {
        return DriveTypeEnum.WASSERSTOFF;
    }
    if (engineType === 'ice' &&
        fuelType1 === 'hydrogen' &&
        fuelType2 === undefined) {
        return DriveTypeEnum.WASSERSTOFF;
    }
    if (engineType === 'fuelCell' &&
        fuelType1 === 'petrol' &&
        fuelType2 === 'hydrogen') {
        return DriveTypeEnum.BRENNSTOFFZELLE_WASSERSTOFF;
    }
    if (engineType === 'fuelCell' &&
        fuelType1 === 'petrol' &&
        fuelType2 === undefined) {
        return DriveTypeEnum.BRENNSTOFFZELLE_BENZIN;
    }
    if (engineType === 'fuelCell' &&
        fuelType1 === 'petrol' &&
        fuelType2 === 'methane') {
        return DriveTypeEnum.BRENNSTOFFZELLE_METHANOL;
    }
    if (engineType === 'fuelCell' &&
        fuelType1 === 'petrol' &&
        fuelType2 === 'ethanol') {
        return DriveTypeEnum.BRENNSTOFFZELLE_ETHANOL;
    }
    if (engineType === 'otherEngine' &&
        fuelType1 === undefined &&
        fuelType2 === undefined) {
        return DriveTypeEnum.NOT_LISTED;
    }
    return null;
};
